import {GROUP_PRIORITIES} from '@nursio-link/common/authorization';
import {ChevronDown, FlaskConical} from 'lucide-react';
import {useState} from 'react';

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import {DEV_GROUPS_STORAGE_KEY} from '@/services/authService';
import {UserGroup} from '@/services/graphqlHooks';
import userGroups from '@/translation/userGroups';
import {cn} from '@/utils/ui';

const SORTED_GROUPS = Object.values(UserGroup).sort(
  (a, b) => GROUP_PRIORITIES[a] - GROUP_PRIORITIES[b]
);

function DevRoleSwitcher() {
  const [active, setActive] = useState<UserGroup | null>(() => {
    const stored = window.sessionStorage.getItem(DEV_GROUPS_STORAGE_KEY);
    if (!stored) return null;
    return (JSON.parse(stored) as UserGroup[])[0] ?? null;
  });

  function apply(group: UserGroup | null) {
    if (group) {
      window.sessionStorage.setItem(
        DEV_GROUPS_STORAGE_KEY,
        JSON.stringify([group])
      );
    } else {
      window.sessionStorage.removeItem(DEV_GROUPS_STORAGE_KEY);
    }
    setActive(group);
    window.location.href = '/';
  }

  const label = active ? userGroups[active] : 'Real role';

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        className={cn(
          'fixed top-4 right-4 z-50',
          'flex items-center gap-1.5 rounded-full px-3 py-2',
          'bg-amber-400 text-xs font-semibold text-amber-950 shadow-md',
          'min-h-9 touch-manipulation outline-none select-none'
        )}
      >
        <FlaskConical className="size-3.5 shrink-0" />
        {label}
        <ChevronDown className="size-3 shrink-0" />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-44">
        <DropdownMenuRadioGroup
          value={active ?? ''}
          onValueChange={value => apply(value as UserGroup)}
        >
          {SORTED_GROUPS.map(group => (
            <DropdownMenuRadioItem key={group} value={group}>
              {userGroups[group]}
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
        {active && (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={() => apply(null)}>
              Reset to real role
            </DropdownMenuItem>
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export default DevRoleSwitcher;
